import { ErrorCodes } from 'src/constants'

export default class ServerResponseError extends Error {
  constructor ({ message, httpStatus, errorCode }) {
    super(message)
    this.name = this.constructor.name

    this.message = message
    this.httpStatus = httpStatus
    this.errorCode = errorCode

    if (httpStatus === 429 && this.errorCode == ErrorCodes.UNKNOWN_ERROR) {
      this.errorCode = ErrorCodes.RATE_LIMIT
    }
  }
}
